import { render, staticRenderFns } from "./OsDetails.vue?vue&type=template&id=3b24f953&scoped=true&"
import script from "./OsDetails.vue?vue&type=script&lang=js&"
export * from "./OsDetails.vue?vue&type=script&lang=js&"
import style0 from "./OsDetails.vue?vue&type=style&index=0&id=3b24f953&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b24f953",
  null
  
)

export default component.exports